import React from 'react';
import * as Sentry from '@sentry/react';
import { Provider as ReduxProvider } from 'react-redux';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import AppContainer from './navigation/appContainer';
import { client } from './core/services/helpers';
import configs from './config';
import './utils/prototype';
import { EventProvider } from './context/EventContext';

//= ====================================//
//= ============== Debug ===============//
//= ====================================//
import VConsole from 'vconsole';
import { isWebView } from './utils/webview';

if (isWebView() && configs?.envConfig?.currentEnv?.isStaging) {
    const vc = new VConsole();

    window.logToVC = (type: 'log' | 'info' | 'debug' | 'warn' | 'error', ...args: any[]) => {
        vc.log[type](...args);
    };
} else {
    window.logToVC = () => {};
}

//= ==================================//
//= ============== App ===============//
//= ==================================//

const isDev: boolean = configs?.appConfig?.isDev;
export const store = configs.storeConfig.createReduxStore();

const App = (): React.ReactElement => {
    return (
        <Sentry.ErrorBoundary fallback={<div>An error has occured</div>}>
            <ReduxProvider store={store}>
                <QueryClientProvider client={client}>
                    <EventProvider>
                        <AppContainer />
                        {isDev && <ReactQueryDevtools initialIsOpen={false} />}
                    </EventProvider>
                </QueryClientProvider>
            </ReduxProvider>
        </Sentry.ErrorBoundary>
    );
};

export default App;
